import { render } from "./NewZone.vue?vue&type=template&id=776a40c2&scoped=true"
import script from "./NewZone.vue?vue&type=script&lang=js"
export * from "./NewZone.vue?vue&type=script&lang=js"

import "./NewZone.vue?vue&type=style&index=0&id=776a40c2&scoped=true&lang=css"

import exportComponent from "/home/accesa/Documents/ACCESA/DANA_PROJECTS/DANA-LITE/dana-lite-registro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776a40c2"]])

export default __exports__